module.exports = __webpack_public_path__ + "img/img.a1f6ae3c.png";